import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQuery } from "./baseQueryWithReauth";

const authApi = createApi({
  reducerPath: "auth",
  baseQuery: baseQuery,
  tagTypes: "Auth",
  endpoints(builder) {
    return {
      forgotPassword: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          return {
            url: `/api/auth/forgot-password`,
            method: "POST",
            body: {
              ...filteredData,
            },
          };
        },
      }),
      login: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          return {
            url: `/api/auth/login`,
            method: "POST",
            body: {
              ...filteredData,
            },
          };
        },
      }),

      logout: builder.mutation({
        query: ({ token }) => {
          return apiFunction({ token }, "/api/auth/logout", "POST");
        },
      }),

      validateTemplateCode: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          return {
            url: `/api/admin/register/validate-code`,
            method: "POST",
            body: { ...filteredData },
          };
        },
      }),
      sendRegistrationCode: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          return {
            url: `/api/admin/register/send-code`,
            method: "POST",
            body: { ...filteredData },
          };
        },
      }),
      verifyAndRegister: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          return {
            url: `/api/admin/register/verify-and-register`,
            method: "POST",
            body: { ...filteredData },
          };
        },
      }),
    };
  },
});

export const {
  useForgotPasswordMutation,
  useLoginMutation,
  useValidateTemplateCodeMutation,
  useSendRegistrationCodeMutation,
  useVerifyAndRegisterMutation,
  useLogoutMutation,
} = authApi;
export { authApi };
